import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Leaf, Lock, User, Spa } from 'lucide-react';

function LoginPage({ setLoggedIn }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/nursery/api/login', {
        username,
        password
      });

      if (res.data.success) {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('branch_id', res.data.user.branch_id);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        setLoggedIn(true);
        navigate('/');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Authentication unsuccessful. Please check credentials.');
    }
  };

  const premiumFont = "'Book Antiqua', 'Baskerville Old Face', 'Times New Roman', serif";

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        background: 'linear-gradient(135deg, #1b4d3e 0%, #2d5a27 100%)',
        fontFamily: premiumFont,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Decorative Elements */}
      <div style={{
        position: 'absolute',
        top: '-10%',
        right: '-10%',
        width: '400px',
        height: '400px',
        background: 'rgba(255,255,255,0.03)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }} />
      <div style={{
        position: 'absolute',
        bottom: '-5%',
        left: '-5%',
        width: '300px',
        height: '300px',
        background: 'rgba(255,255,255,0.03)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }} />

      <div
        className="card shadow-lg border-0 p-5"
        style={{
          width: '440px',
          borderRadius: '24px',
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
        }}
      >
        <div className="text-center mb-5">
          <div className="d-inline-flex p-3 rounded-4 mb-3" style={{ background: '#f0fdf4', color: '#1b4d3e' }}>
            <Leaf size={40} />
          </div>
          <h2 className="fw-bold mb-1" style={{ color: '#1b4d3e', letterSpacing: '0.5px' }}>
            Nasmat Al Zohour
          </h2>
          <p className="text-muted small">Intelligence & Management Portal</p>
        </div>

        {error && (
          <div className="alert alert-danger border-0 rounded-3 small py-2 mb-4" style={{ background: '#fef2f2', color: '#991b1b' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label className="form-label small fw-bold text-muted mb-2 ps-1">
              Gateway Identity
            </label>
            <div className="input-group">
              <span className="input-group-text bg-transparent border-end-0 text-muted" style={{ borderRadius: '12px 0 0 12px' }}>
                <User size={18} />
              </span>
              <input
                type="text"
                className="form-control border-start-0 py-2"
                style={{ borderRadius: '0 12px 12px 0', border: '1px solid #e2e8f0' }}
                placeholder="Manager ID"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="mb-5">
            <label className="form-label small fw-bold text-muted mb-2 ps-1">
              Secure Protocol
            </label>
            <div className="input-group">
              <span className="input-group-text bg-transparent border-end-0 text-muted" style={{ borderRadius: '12px 0 0 12px' }}>
                <Lock size={18} />
              </span>
              <input
                type="password"
                className="form-control border-start-0 py-2"
                style={{ borderRadius: '0 12px 12px 0', border: '1px solid #e2e8f0' }}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn w-100 py-3 fw-bold text-white shadow-lg"
            style={{
              background: 'linear-gradient(135deg, #c9a03d 0%, #b8860b 100%)',
              borderRadius: '16px',
              border: 'none',
              fontSize: '16px',
              letterSpacing: '1px',
              transition: 'transform 0.2s'
            }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
          >
            INITIALIZE SESSION
          </button>
        </form>

        <div className="text-center mt-5">
          <p className="text-muted small mb-0 px-4" style={{ lineHeight: '1.4' }}>
            Unauthorized access is strictly prohibited under federal environmental intelligence protocols.
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
